import { render, staticRenderFns } from "./LunchMenuView.vue?vue&type=template&id=234f402f&scoped=true&"
import script from "./LunchMenuView.vue?vue&type=script&lang=js&"
export * from "./LunchMenuView.vue?vue&type=script&lang=js&"
import style0 from "./LunchMenuView.vue?vue&type=style&index=0&id=234f402f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234f402f",
  null
  
)

export default component.exports